/**
 * 按钮级权限指令
 *
 * 用法：
 *   <el-button v-permission="'sys:user:add'">新增</el-button>
 *   <el-button v-permission="['sys:user:edit', 'sys:user:add']">操作</el-button>
 *
 * 数组表示「任一命中」即显示。无权限时直接移除节点。
 */
import store from '@/store'

function check(value) {
  return store.getters['user/hasPermission'](value)
}

export default {
  mounted(el, binding) {
    if (!check(binding.value)) {
      el.parentNode?.removeChild(el)
    }
  },
  updated(el, binding) {
    if (!check(binding.value)) {
      el.style.display = 'none'
    } else {
      el.style.display = ''
    }
  }
}
